import "./App.css";
import CryptoJS from "crypto-js";
import Web3 from "web3";
import { useEffect, useState } from "react";
import VPFileSharing from "./VPFileSharing";
import Container from "@material-ui/core/Container";
import { TextField } from "@material-ui/core";
import { RemoveCircle } from "@material-ui/icons";
import IconButton from "@material-ui/core/IconButton";
import AddIcon from "@material-ui/icons/Add";
import InputAdornment from '@mui/material/InputAdornment';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { client } from "./Config.js";
import '@rainbow-me/rainbowkit/styles.css';
import {
  getDefaultWallets,
  RainbowKitProvider,
} from '@rainbow-me/rainbowkit';
import {
  chain,
  configureChains,
  createClient,
  WagmiConfig,
  useAccount
} from 'wagmi';
import { infuraProvider } from 'wagmi/providers/infura';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { publicProvider } from 'wagmi/providers/public';

const infuraId = process.env.INFURA_ID;

    const { chains, provider } = configureChains(
    [chain.ropsten],
    [infuraProvider({ infuraId }),publicProvider(),]
)
const { connectors } = getDefaultWallets({
    appName: 'My RainbowKit App',
    chains
  });
  
  const wagmiClient = createClient({
    autoConnect: true,
    connectors,
    provider
  })

  export const LoggedIn = () => {
    return (
      <ConnectButton.Custom>
        {({
          account,
          chain,
          openAccountModal,
          openChainModal,
          openConnectModal,
          mounted,
        }) => {
          return (
            <div
              {...(!mounted && {
                'aria-hidden': true,
                'style': {
                  opacity: 0,
                  pointerEvents: 'none',
                  userSelect: 'none',
                },
              })}
            >
              {(() => {
                if (!mounted || !account || !chain) {
                  return (
                   
                    <button className='text-xl text-white border-2 border-maroon hover:border-gold hover:text-deepDarkBg desktop:pl-3 desktop:pt-2 desktop:pr-3 desktop:pb-2
                    mobile:pl-2 mobile:pr-2 mobile:pb-1 mobile:pt-1 border-1 border-red 
                    ' onClick={openConnectModal} style={{borderRadius: "15px"}}>Log in</button>
                    
                    
                  );
                }
  
                if (chain.unsupported) {
                  return (
                    <button onClick={openChainModal} type="button" style={{borderRadius: "15px", display: "block", marginLeft: "auto", marginRight: "0"}}>
                      Wrong network
                    </button>
                  );
                }
  
                return (
                  <div className='desktop:w-6 laptop:w-6 mobile:w-4' style={{ display: 'flex', gap: 5}} >
                
                    <button
                      onClick={openAccountModal}
                      style={{ display: 'flex', alignItems: 'center' }}
                     
                      type="button"
                    >
                      {chain.hasIcon && (
                        <div
                          style={{
                            background: chain.iconBackground,
                            width: 25,
                            height: 25,
                            borderRadius: 999,
                            overflow: 'hidden',
                            marginRight: 4,
                          }}
                        >
                          {chain.iconUrl && (
                            <img
                              alt={chain.name ?? 'Chain icon'}
                              src={chain.iconUrl}
                              style={{ width: 25, height: 25 }}
                            />
                          )}
                        </div>
                      )}
                      {/* {chain.name} */}
                    </button>
                   
  
                    {/* <button onClick={openAccountModal} type="button" className="text-xs font-light" style={{borderRadius: "15px", display: "block", marginLeft: "auto", marginRight: "0", fontFamily: "Barlow"}}/> */}
                  </div>
                );
              })()}
            </div>
          );
        }}
      </ConnectButton.Custom>
    );
  };

  export const YourApp = () => {
    return (
      <ConnectButton.Custom>
        {({
          account,
          chain,
          openAccountModal,
          openChainModal,
          openConnectModal,
          mounted,
        }) => {
          return (
            <div
              {...(!mounted && {
                'aria-hidden': true,
                'style': {
                  opacity: 0,
                  pointerEvents: 'none',
                  userSelect: 'none',
                },
              })}
            >
              {(() => {
                if (!mounted || !account || !chain) {
                  return (
                    
                    <button className=' text-center text-xl text-white border-2 border-maroon hover:border-gold hover:text-deepDarkBg desktop:pl-3 desktop:pt-2 desktop:pr-3 desktop:pb-2
                    mobile:pl-2 mobile:pr-2 mobile:pb-1 mobile:pt-1 border-1 border-red 
                    ' onClick={openConnectModal} style={{borderRadius: "15px", margin:"0 auto", display:"block"}}>Log in</button>
                    
                  );
                }
  
                if (chain.unsupported) {
                  return (
                    <button onClick={openChainModal} type="button">
                      Wrong network
                    </button>
                  );
                }
  
                return (
                  <div className='desktop:w-6 laptop:w-6 mobile:w-4' style={{ display: 'flex', gap: 5 }}>
                    <button
                      onClick={openAccountModal}
                      style={{ display: 'flex', alignItems: 'center' }}
                      type="button"
                    >
                      {chain.hasIcon && (
                        <div
                          style={{
                            background: chain.iconBackground,
                            width: 25,
                            height: 25,
                            borderRadius: 999,
                            overflow: 'hidden',
                            marginRight: 4,
                          }}
                        >
                          {chain.iconUrl && (
                            <img
                              alt={chain.name ?? 'Chain icon'}
                              src={chain.iconUrl}
                              style={{ width: 25, height: 25 }}
                            />
                          )}
                        </div>
                      )}
                      {chain.name}
                    </button>
  
                    <button onClick={openAccountModal} type="button" className="text-xs font-light" style={{fontFamily: "Barlow"}}/>
                  </div>
                );
              })()}
            </div>
          );
        }}
      </ConnectButton.Custom>
    );
  };

    const cfg = {
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    };

export function Interface() {
  const [address, setAddress] = useState(null);
  const [contract, setContract] = useState(null);
  const [FName, setFName] = useState(null);
  const [FDesc, setFDesc] = useState(null);
  const [yourName, setYourName] = useState(null);
  const [AllFName, setAllFName] = useState([]);
  const [AllFDesc, setAllFDesc] = useState([]);
  const [FLModified, setFLModified] = useState([]);
  const [TeamMembers, setTeamMembers] = useState([]);
  const [Authorized, setAuthorized] = useState([]);
  const [AuthorizedArr, setAuthorizedArr] = useState([]);
  const [AuthorizedName, setAuthorizedName] = useState([]);
  const [fileOwner, setFileOwner] = useState([]);
  const [eHash, setEHash] = useState("");
  const [currentMilestone, setCurrentMilestone] = useState([]);
  const [addAccess, setAddAccess] = useState([]);
  const [addAccessName, setAddAccessName] = useState([]);
  const [removeAccess, setRemoveAccess] = useState([]);
  const [connected, setConnected] = useState(false);
  const [hashFromContract, setHashFromContract] = useState([]);

  var [totalfiles, setTotalFiles] = useState(null);
  const [inputFields, setInputField] = useState([{ wallet: "", name: ""}]);


    function Profile() {
      const {account, isConnected} = useAccount({
        onConnect({ address }) {
        setConnected(true)
    }
    }
  )}

    useEffect(() => {
      async function load() {
        const web3 = new Web3(window.ethereum);
        const accounts = await web3.eth.getAccounts()
        setAddress(accounts[0])
        console.log(accounts[0]);
        var contract = VPFileSharing(web3);
        setContract(contract);
        const TFiles = await contract.methods.count().call();
        const TotalFiles = Number(TFiles);
        setTotalFiles(TotalFiles)
  
          for(var i = 0; i<TotalFiles; i++){
          var AuthorizedMembers = await contract.methods.getAuthorized(i).call()
          setAuthorized((Authorized) => [...Authorized, AuthorizedMembers])
          var name = await contract.methods.getFileName(i).call()
          var desc = await contract.methods.getFileDesc(i).call()
          var lastModified = await contract.methods.getLastModified(i).call()
          var TMembers = await contract.methods.getTeam(i).call()
          var fileowner = await contract.methods.getFileOwnerAddress(i).call()
          var cMilestone = await contract.methods.getcurrentMilestone(i).call()
          const encryptedHash = await contract.methods.getencryptedHash(i).call()

            setHashFromContract((hashFromContract) => [...hashFromContract, encryptedHash])
            setAllFName((AllFName) => [...AllFName, decryptData(name)])
            setAllFDesc((AllFDesc) => [...AllFDesc, decryptData(desc)])
            setFLModified((FLModified) => [...FLModified, lastModified])
            setTeamMembers((TeamMembers) => [...TeamMembers, TMembers])
            setFileOwner((fileOwner) => [...fileOwner, fileowner])
            setCurrentMilestone((currentMilestone) => [...currentMilestone, cMilestone])
          }
         
        }
        load();
    },[]);

        async function load() {
        const web3 = new Web3(window.ethereum);
        const accounts = await web3.eth.getAccounts()
        setAddress(accounts[0])
        console.log(accounts[0]);
        var contract = VPFileSharing(web3);
        setContract(contract);
        const TFiles = await contract.methods.count().call();
        const TotalFiles = Number(TFiles);
        setTotalFiles(TotalFiles)
  
          for(var i = TotalFiles-1; i>=0; i--){
          var AuthorizedMembers = await contract.methods.getAuthorized(i).call()
          setAuthorized((Authorized) => [...Authorized, AuthorizedMembers])
          var name = await contract.methods.getFileName(i).call()
          var desc = await contract.methods.getFileDesc(i).call()
          var lastModified = await contract.methods.getLastModified(i).call()
          var TMembers = await contract.methods.getTeam(i).call()
          var fileowner = await contract.methods.getFileOwnerAddress(i).call()
          var cMilestone = await contract.methods.getcurrentMilestone(i).call()

            setAllFName((AllFName) => [...AllFName, decryptData(name)])
            setAllFDesc((AllFDesc) => [...AllFDesc, decryptData(desc)])
            setFLModified((FLModified) => [...FLModified, lastModified])
            setTeamMembers((TeamMembers) => [...TeamMembers, TMembers])
            setFileOwner((fileOwner) => [...fileOwner, fileowner])
            setCurrentMilestone((currentMilestone) => [...currentMilestone, cMilestone])
          }
        }
        
      

  
  const handleChangeInput = (index, event) => {
    const values = [...inputFields];
    values[index][event.target.name] = event.target.value;
    setInputField(values);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const web3 = new Web3(window.ethereum);
    const accounts = await web3.eth.getAccounts()
    var contract = VPFileSharing(web3);
    let walletArr = [];
    let nameArr = [];
    let HashArr = [];
    for (var i = 0; i < inputFields.length; i++) {
      walletArr.push(inputFields[i].wallet);
      nameArr.push(inputFields[i].name);
    }
    HashArr.push(eHash);
    console.log(FName)
    console.log(FDesc)
    console.log(yourName)
    console.log(HashArr)
    console.log(walletArr)
    console.log(AuthorizedArr)
    console.log(nameArr)
    console.log(AuthorizedName)

    try{
    await contract.methods
      .AddFile(FName, FDesc, yourName, HashArr, walletArr, AuthorizedArr, nameArr, AuthorizedName).send({
        from: accounts[0]
      });

  } catch(err){
    console.log(err);
  }
  };

  const handleAdd = () => {
    if (inputFields.length < 10)
      setInputField([...inputFields, { wallet: "", name: "" }]);
  };

  const handleRemove = (index) => {
    if (inputFields.length > 1) {
      const values = [...inputFields];
      values.splice(index, 1);
      setInputField(values);
    }
  };

  const handleAddAuthorized = (index, event) => {
    if (event.target.checked && inputFields[index].wallet != "" && inputFields[index].name != "") {
      const wallets = inputFields[index].wallet;
      const authNames = inputFields[index].name;
      console.log(wallets, authNames);
      setAuthorizedName((AuthorizedName) => [...AuthorizedName, authNames]);
      setAuthorizedArr((AuthorizedArr) => [...AuthorizedArr, wallets])
    }
  };


  const setFileName = (event) => {
    let val = event.target.value;
    let encval = encryptData(val);
    setFName(encval);
  };
  const setFileDesc = (event) => {
    let val = event.target.value;
    let encval = encryptData(val);
    setFDesc(encval);
  };
  const setnewAccess = (event) => {
    let val = event.target.value;
    setAddAccess(val)
  };
  const setnewAccessName = (event) => {
    let val = event.target.value;
    setAddAccessName(val)
  };
  
  const removenewAccess = (event) => {
    let val = event.target.value;
    setAddAccess(val)
  };


  function encryptData(contractData){
    var key = CryptoJS.enc.Base64.parse("my-secret-key@123");
    var iv  = CryptoJS.enc.Base64.parse("");
    var encrypted = CryptoJS.AES.encrypt(contractData, key, {iv: iv});
    return encrypted.toString();
  };

  function decryptData(contractData){
    var key = CryptoJS.enc.Base64.parse("my-secret-key@123");
    var iv  = CryptoJS.enc.Base64.parse("");
    var decrypted = CryptoJS.AES.decrypt(contractData, key, {iv: iv});
    var readableForm = (decrypted.toString(CryptoJS.enc.Utf8));
    return readableForm;
  };


  function encryptHash(contractData){
    var key = CryptoJS.enc.Base64.parse("my-secret-key@123");
    var iv  = CryptoJS.enc.Base64.parse("");
    var encrypted = CryptoJS.AES.encrypt(contractData, key, {iv: iv});
    console.log(encrypted.toString)
    return encrypted.toString();
    // return encrypted;
  };

  function decryptHash(contractData){
    var key = CryptoJS.enc.Base64.parse("my-secret-key@123");
    var iv  = CryptoJS.enc.Base64.parse("");
    var decrypted = CryptoJS.AES.decrypt(contractData, key, {iv: iv});
    console.log(decrypted.toString(CryptoJS.enc.Utf8));
    var readableForm = (decrypted.toString(CryptoJS.enc.Utf8));
    const url = `https://alosharing.infura-ipfs.io/ipfs/${readableForm}`;
    return url;
  };


  return (
    <>
    <div className="mx-16 pt-36">
    <div style={{position:"absolute", right:"100px", top:"30px"}}>
    <WagmiConfig client={wagmiClient}>
    <RainbowKitProvider chains={chains}>
    <LoggedIn />
    <Profile />
    </RainbowKitProvider>
    </WagmiConfig>
    </div>
    <section id="Create">
    <div className="Form">
    <div className="container create-container mx-auto my-auto">
      <form>
        <div id="people-container">
          <h1 className="text-2xl pb-8 font-bold">New File</h1>
          <p>
            <label className="font-semibold">File name</label>
            <br></br>
            <input className="ml-12 mr-12" onChange={setFileName}></input>
          </p>

          
            <div className="input-box pt-5">
            <label className="font-semibold">Content</label>
            <textarea onChange={setFileDesc} name="content" rows="4" cols="75"></textarea>
          </div>
            {/* <input onChange={setFileDesc}></input> */}
          
          <p className="pt-2 pb-2">Your Wallet: {address}</p>
          <span>Your Name: </span><input placeholder=' Name' onChange={(event)=>{setYourName(event.target.value)}}></input>
          <Container className="pt-4">
            <label className="font-semibold">Team Members</label>
            <br></br>
           
              {inputFields.map((inputField, index) => (
                <div key={index}>
                  <input
                  style={{marginRight: "10px", marginTop: "25px"}}
                    type="checkbox"
                    onChange={(event) => handleAddAuthorized(index, event)}
                  />
                  
                  <TextField
                    name="wallet"
                    label="wallet"
                    variant="filled"
                    value={inputField.wallet}
                    onChange={(event) => handleChangeInput(index, event)}
                  />
                  
                  <TextField
                    name="name"
                    label="name"
                    variant="outlined"
                    value={inputField.name}
                    onChange={(event) => handleChangeInput(index, event)}
                  />
                 
                  <IconButton onClick={() => handleRemove(index)}>
                    <RemoveCircle />
                  </IconButton>
                  <IconButton onClick={() => handleAdd()}>
                    <AddIcon />
                  </IconButton>
                </div>
              ))}
            
          </Container>
        </div>
        <label>
          <input
            className="pt-5"
            placeholder="input"
            type="file"
            onChange={async (e) => {
              const file = e.target.files[0];
              console.log(file);
              console.log(client);
              const add = await client.add(file);
              const final = await client.pin.add(add.path);
          
              const ciphertext = encryptHash(add.path)
              setEHash(ciphertext);

            }}
          ></input>
        </label> <br/>
        <button type="submit" className="btn-grad-black mt-5 pl-24 pr-24" onClick={handleSubmit}>Submit</button>
      </form>
      </div>
      </div>
      </section>

      <section id="YourContributions">
        <h1 className='text-white text-center mt-32'>Authorized</h1>
        <div className="row container-fluid mx-auto my-auto">
        {AllFName.map((Item, index) => {
        
        var BtoDate = (new Date(FLModified[index]*1000));
        var Day = BtoDate.getDate();
        var Month = BtoDate.toLocaleString('default', { month: 'long' });
        var Year = BtoDate.getFullYear();
        var Hour = BtoDate.toLocaleTimeString();

        

        return (
          <>
          {Authorized[index].includes(address) ? 
          <div style={{display: "inline-block"}} className="col-lg-6 col-md-6 Card" key={index}>
          <h4>Name</h4>
          <span style={{fontSize:"15px"}} id="Value">{AllFName[index]}</span> <br />
          <h4>Description</h4>
          <span style={{fontSize:"15px"}}>{AllFDesc[index]}</span> <br />
          <h4>Last Modified</h4>
          <span style={{fontSize:"15px"}}>{Day} {Month} {Year} {Hour}</span> <br />
          {(address == fileOwner[index])? 
          (<div>    
        <TextField
        id="input-with-icon-textfield"
        label="Wallet"
        onChange={(event) => setnewAccess(event)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <AccountCircle />
            </InputAdornment>
          ),
        }}
        variant="standard"
      /> <br/>
      <TextField
        id="input-with-icon-textfield"
        label="Name"
        onChange={(event) => setnewAccessName(event)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <AccountCircle />
            </InputAdornment>
          ),
        }}
        variant="standard"
      /> <br/>
          <button onClick={
            async function(){
              await contract.methods.AddAccess(index, addAccess, addAccessName).send({
            from : address
          })}
          }
           className="mt-4 mb-4">Add Access</button>
           <button onClick={
            async function(){
              await contract.methods.removeAccess(index, addAccess).send({
            from : address
          })}
          }
           className="mt-4 mb-4">Remove Access</button>

           <br/>
            </div>) : null}
          <label>
          <input
            placeholder="input"
            type="file"
            onChange={async (e) => {
              const file = e.target.files[0];
              console.log(file);
              console.log(client);
              const add = await client.add(file);
              const final = await client.pin.add(add.path);
              const ciphertext = encryptHash(add.path)
              setEHash(ciphertext);
        
            }}
          ></input> 
          
        </label><br/><button style={{marginBottom: "1rem", marginTop: "2rem"}} onClick={
            async function(){ 
              if(eHash !== ''){
              await contract.methods.updateHash(index, eHash).send({
            from : address
          })}
          else{
            alert("Please upload updated file!")
          }}}>Update File</button><br/>
          <button className="mb-5" onClick={async () => {
            const encryptedHash = hashFromContract[index]
            const totalHashes = encryptedHash.length;
            const link = await decryptHash(encryptedHash[totalHashes-1]);
            window.open(link);
            }}>Download</button> <br/>
            <h4>Current Milestone</h4>
            {currentMilestone[index] == 1 ? (<><span style={{fontSize:"15px"}}>{currentMilestone[index]}</span> <br /></>) : (<><span style={{fontSize:"15px"}}>Milestone has been updated to Milestone {currentMilestone[index]}</span> <br /></>)}
          
          {(address == fileOwner[index])? (<><button style={{marginBottom: "1rem",marginTop: "2rem"}} onClick={
            async function(){ 
              await contract.methods.updateMilestones(index).send({
            from : address
          })}} >Update Milestone</button> <button style={{marginBottom: "1rem",marginTop: "2rem"}} onClick={
            async function(){ 
              await contract.methods.approveProject(index).send({
            from : address
          })}} >Approve Project</button></>) : null}
        
          </div> : null}
          </>
          );
          
        }
          ) }
        
        
      </div>
      </section>



        <section id="YourContributions">
        <h1 className='text-white text-center mt-24'>All Files</h1>
        <div className="row container-fluid">
        {AllFName.map((Item, index) => {
        
        var BtoDate = (new Date(FLModified[index]*1000));
        var Day = BtoDate.getDate();
        var Month = BtoDate.toLocaleString('default', { month: 'long' });
        var Year = BtoDate.getFullYear();
        var Hour = BtoDate.toLocaleTimeString();
        return (
          <>
          {(!Authorized[index].includes(address) && TeamMembers[index].includes(address))? 
          <div style={{display: "inline-block"}} className="col-lg-12 col-md-12 CardAll" key={index}>
          {/* {index + 1} <br></br> */}
          <h4>Name</h4>
          <span style={{fontSize:"15px"}} id="Value">{AllFName[index]}</span> <br />
          <h4>Description</h4>
          <span style={{fontSize:"15px"}}>{AllFDesc[index]}</span> <br />
          <h4>Last Modified</h4>
          <span className="mb-5" style={{fontSize:"15px"}}>{Day} {Month} {Year} {Hour}</span> <br />
          
          </div> : null}
          </>
          );
        }
          ) }
        
        
      </div>
      </section>

    </div>
  
    </>
  );
  
}

function App() {
  const [connected, setConnected] = useState(false)
  function Profile() {
    const {account, isConnected} = useAccount({
      onConnect({ address }) {
      setConnected(true)
  }
  }
)}


return(
  <>
  
    {connected ? (<Interface />) : (
    <div className="boxx bg-black">
    <div className="mt-24">
      <h1 className="text-white text-center pb-10">VP File Sharing Portal</h1>
      <WagmiConfig client={wagmiClient}>
      <RainbowKitProvider chains={chains}>
      <YourApp />
      <Profile />
      </RainbowKitProvider>
      </WagmiConfig>
      </div>
    </div>
    )}
  </>
);
}

export default App;